module.exports = __webpack_public_path__ + "static/media/check-green.d44752fa.svg";